export const useFakePagination = <T>({
  currentPage,
  data,
  take,
}: {
  currentPage: number;
  data: T[];
  take: number;
}) => ({
  data: data.slice((currentPage - 1 || 0) * take, (currentPage - 1 || 0) * take + take),
  totalPages: Math.ceil(data.length / take),
});
